import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import viewAppCategories from './../viewRelatedAppCategories';
import viewRelatedAppPackages from './../viewRelatedAppPackages';
import viewRelatedSportRoomTeams from '../viewRelatedSportRoomTeams';
import { OPERATING_SYSTEMS } from '../../utils/operatingSystemUtils';

export default {
  title: 'New Room config Info',
  attributeName: 'sportRoomConfigInfoNew',
  fields: [
    {
      attributeName: 'mainhubApp',
      helpText: 'Whitelabel Pro app',
      type: FormInputTypes.SELECT,
      label: 'WL Pro app',
      placeholder: 'Please enter to select a App',
      multiple: false,
      url: 'mainHubs/index',
      disabledWhenEdit: true,
      emptyValue: true,
      childField: 'config',
      default: '(Empty)', //default value to empty option
      fieldValue: 'id',
      fieldName: 'name',
      asyncSelect: true,
      flushChildrenOnchange: 'sportRoom',
    },
    {
      attributeName: 'sportRoom',
      helpText: 'Room',
      type: FormInputTypes.SELECT,
      label: 'Room',
      placeholder: 'Please enter to select a Room',
      multiple: false,
      url: 'liveSportRoomslist',
      disabledWhenEdit: true,
      emptyValue: true,
      childField: 'config',
      default: '(Empty)', //default value to empty option
      fieldValue: 'id',
      fieldName: 'name',
      asyncSelect: true,
      filter: "name",
      parentField: "mainhubApp",
      loadInitialWithoutParent: true,
      writable: true,
      ignoreEmptyValue: true,
      noOptionsMessageText: 'No spaces available for the selected app',
      customStyles: {
        control: {
          width: '100%'
        },
        menu: {
          width: '100%'
        }
      },
      onChangeSetField: {
        target: 'mainhubApp',
        fromOptionField: 'mainHubId',
      },
    },
    {
      attributeName: 'config',
      helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
      type: FormInputTypes.SELECT,
      ifParentAttributName: ['sportRoomConfigInfoNew', 'sportRoomConfigInfoEdit'],
      disabledWhenEdit: true,
      label: 'Config',
      placeholder: 'Please enter to add a valid config',
      multiple: false,
      url: 'liveConfigslist',
      parentField: 'sportRoom',
      enabledWhen: { "field": "sportRoom", "notValues": ['(Empty)'] },
      emptyValue: true,
      default: '(Empty)',
      allValue: '(All)',
      fieldValue: 'id',
      fieldName: 'name',
      asyncSelect: true,
      options: [],
      writable: true,
      noOptionsMessageText: 'No spaces available for the selected app',
      customStyles: {
        control: {
          width: '100%'
        },
        menu: {
          width: '100%'
        }
      },
      onChangeSetField: {
        target: 'operatingSystem',
        fromOptionField: 'operatingSystem',
      },
    },
    {
      attributeName: 'operatingSystem',
      label: 'operatingSystem',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      hidden: true,
    },
    {
      attributeName: "sep1",
      type: FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Content name',
      label: 'Name',
      required: true,
      helpText: 'Name of the content',
      errorText: '',
    },
    {
      attributeName: 'composeExperienceUrl',
      helpText: 'Select a valid media Url',
      type: FormInputTypes.SELECT,
      label: 'Media Url',
      placeholder: 'Please add a valid url',
      multiple: false,
      url: 'liveComposeExperienceList',
      emptyValue: true,
      default: '(Empty)', //default value to empty option
      fieldValue: 'id',
      fieldName: 'url',
      asyncSelect: true,
      pageId: true,
      options: [],
    },
    // {
    //   attributeName: 'duration',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   label: 'Duration',
    //   placeholder: 'Video duration...',
    //   helpText: 'Duration of the video in the format mm:ss.',
    // },
    {
      attributeName: "sep2",
      type: FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'visibility',
      label: 'Visibility',
      helpText: 'Visibility of the video in the panel its listed.',
      default: 'enabled',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation Time',
      helpText: 'Date of the activation event for this video in clients.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName: 'startEpoch',
      label: 'Starting Time',
      helpText: 'Date of the starting event countdown.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName: 'isLiveContinuous',
      label: 'Remove Progress Indicator',
      helpText: 'Selecting this field hides the current progress indicator from the player bar, making it invisible to the end user. This option should remain checked for 24/7 live streams.',
      default: false,
      type: FormInputTypes.CHECKBOX,
      confirmPopup: true,
      confirmText: "Are you sure you want to change the visibility of the current progress indicator on this content?"
    },

    {
      attributeName: 'isLiveChannel',
      label: 'Is Live Channel',
      helpText: 'Selecting this field we indicate the live event is a live channel to assign the corresponding tag.',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'liveStatus',
      label: 'Stream Status',
      helpText: 'Check the status of a live event (STOPPED, ONGOING, ENDED).',
      default: 'stopped',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Offline', value: 'offline' },
        { name: 'Live Ongoing', value: 'ongoing' },
        { name: 'Live Ended', value: 'ended' },
      ],
    },
    {
      attributeName: "sep3",
      type: FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'appCategories',
      label: 'Categories',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      configFile: viewAppCategories,
      paramWhen: [{ "field": "sportRoom", "value": ["", "obj", "appId"] }, { "field": "config", "value": ["", "obj", "areaId"] }],
      default: [],
      helpText: 'Video categories joined.',
      enabledWhen: { "field": "config", "notValues": ['(Empty)', '(All)'] },
    },
    {
      attributeName: 'appPackages',
      label: 'In App Purchases SKU provider',
      type: FormInputTypes.RELATIONSHIP,
      maxElements: 1,
      disabledWhenNew: true,
      onSelectUrl: 'appContentSportRoomCheck',
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedAppPackages,
      default: [],
      helpText: 'This content can be blocked by a sku registered on Oculus APP purchases, select one or multiple providers to block it.',
    },
    {
      attributeName: "sep4",
      type: FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'geometry',
      label: 'Geometry',
      helpText: 'Signaling version of the video.',
      default: 'v2',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Autodetect', value: 'v2' },
        { name: 'Equirectangular', value: 'equirectangular' },
        { name: 'Equidome', value: 'equidome' },
        { name: 'Flat', value: 'flat' },
      ],
    },
    {
      attributeName: 'type',
      label: 'Type',
      default: 'mono',
      type: FormInputTypes.SELECT,
      helpText: 'Whether the video is mono or stereo.',
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Stereo', value: 'stereo' },
        { name: 'Stereo LR', value: 'stereolr' },
      ],
      visibleWhen: [{ "field": "geometry", "notValue": "v2" }]

    },
    {
      attributeName: 'isAudioRecordingAllowed',
      helpText: 'Specifies if the content allow audio feedback.',
      label: 'Allow Audio feedback ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isSlowMotionAllowed',
      helpText: 'Specifies if the content allow slow motion. ',
      label: 'Allow Slow motion ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isTimeShiftingAllowed',
      helpText: 'Specifies if the content allow slow motion.',
      label: 'Allow Timeshift ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'allow_casting',
      helpText: 'Specifies if the content allow casting.',
      label: 'Allow Casting ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'allow_screen_recording',
      helpText: 'Specifies if the content allow screen recording.',
      label: 'Allow Recording ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: "sepTeams",
      type: FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'appTeams',
      label: 'Teams',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedSportRoomTeams,
      helpText: 'Teams involved in this content, first will be the home team.',
    },
    {
      attributeName: "sep4",
      type: FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'backgroundFlat',
      type: FormInputTypes.BACKGROUND,
      label: 'Background Flat',
      helpText: 'Background to use in the flat video geometries.',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
    {
      attributeName: 'background180',
      type: FormInputTypes.BACKGROUND,
      label: 'Background 180',
      helpText: 'Background to use in the 180 video geometries.',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ]
    },

    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster',
      helpText: 'Any valid url to a PNG poster image file.',
      placeholder: 'Video poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
    {
      attributeName: 'largePoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Large Poster',
      helpText: 'Any valid url to a PNG poster image file to use inside a side panel.',
      placeholder: 'Video large poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
    {
      attributeName: 'descriptionPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Description Poster',
      helpText: 'URL to the poster image file that will be show in the description panel.',
      placeholder: 'Video description poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'xxl',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XXL Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'xlVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XL Vertical Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'xlHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XL Horizontal Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'lVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'L Vertical Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'lHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'L Horizontal Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'm',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'M Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'sVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'S Vertical Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],

    },
    {
      attributeName: 'sHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'S Horizontal Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
    {
      attributeName: 'xs',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XS Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect: false,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster - 294x170',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 294, height: 170 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect: false,
      fileType: ['image/*'],
      visibleWhen: [{ field: 'operatingSystem', value: OPERATING_SYSTEMS.androidXR.key, or: true }],
    },
    {
      attributeName: 'heroPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Hero Poster - 848x306',
      allowedSizes: [
        { width: 848, height: 306 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      visibleWhen: [{ field: 'operatingSystem', value: OPERATING_SYSTEMS.androidXR.key, or: true }],
    },
    {
      attributeName: 'tags',
      helpText: 'List of tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Tags',
      multiple: true,
      placeholder: 'Press enter to add a tag...',
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
    {
      attributeName: 'description',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'Description',
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },

    {
      attributeName: 'producers',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Producers',
      placeholder: 'Video producers...',
      helpText: 'Producers of the video.',
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
    {
      attributeName: 'isHighQuality',
      label: 'Is High Quality',
      helpText: 'Whether the video is in 8K quality.',
      default: false,
      type: FormInputTypes.CHECKBOX,
      visibleWhen: [
        { field: 'operatingSystem', value: OPERATING_SYSTEMS.oculusQuest.key, or: true },
        { field: 'operatingSystem', value: undefined, or: true },
        { field: "operatingSystem", value: OPERATING_SYSTEMS.visionOS.key, or: true }
      ],
    },
  ],

};
